<template>
	<section id="fast-food">
		<b-row>
			<b-col md="8">
				<h5>Deserts <small class="pl-4 text-muted">16 items</small></h5>
			</b-col>
			<b-col md="4" class="text-right">
				<button class="btn mr-3" @click="prev">
					<i class="fa fa-angle-left" aria-hidden="true"></i>
				</button>				
				<button class="btn"  @click="next">
					<i class="fa fa-angle-right" aria-hidden="true"></i>
				</button>
			</b-col>
		</b-row>
		<b-row class="mt-4">
			<b-col md="12">
				<carousel :autoplay="false" :nav="false" :dots="false" :items="3">
					<DesertCard></DesertCard>
					<DesertCard></DesertCard>
					<DesertCard></DesertCard>
					<DesertCard></DesertCard>
					<DesertCard></DesertCard>
					<DesertCard></DesertCard>
				</carousel>
			</b-col>
		</b-row>
	</section>
</template>

<script>
import carousel from 'vue-owl-carousel'
import DesertCard from './DesertCard'
export default {
	name: "Menu",
	components: { carousel, DesertCard },
	methods: {
		next(){
            $('.owl-next').click()                                
        },
        prev()
        {                
            $('.owl-prev').click()                
        }
	}
}
</script>